import _partialRight from 'lodash/partialRight';

export const parseInteger: (target: string) => number = _partialRight(parseInt, 10);
export const copyToClipboard = (element: HTMLInputElement) => {
  element.select();
  document.execCommand('copy');
};
